"use strict";
// packages/rdti-schema/src/versions/fy24.ts
//
// FY24 (2023-24 income year) schema. Mirrors the legacy hardcoded columns on
// `projects` and `researchActivities` so existing rows migrate 1:1 — every
// FY24 column maps to one FieldDef key here. Do NOT modify after release;
// historical projects depend on this shape.
Object.defineProperty(exports, "__esModule", { value: true });
exports.FY24 = void 0;
exports.FY24 = {
    version: 'FY24',
    effectiveFrom: '2023-07-01',
    source: 'legacy-avanzu-columns (pre-2025-08-15 AusIndustry form)',
    project: [
        {
            key: 'project.description',
            questionNumber: 0,
            label: 'Project description',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: ['technical', 'uncertainty', 'research', 'development'],
                redFlags: ['business requirement', 'customer request', 'market research', 'commercial'],
                weight: 0.15,
            },
        },
        {
            key: 'project.objectives',
            questionNumber: 0,
            label: 'Objectives',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: ['measurable', 'objective', 'demonstrate', 'achieve', 'knowledge'],
                redFlags: ['sales', 'revenue', 'market share'],
                weight: 0.1,
            },
        },
        {
            key: 'project.hypothesis',
            questionNumber: 0,
            label: 'Hypothesis',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: ['hypothesis', 'we believe', 'expect', 'if', 'then', 'because'],
                redFlags: ['trial and error', 'trial-and-error', 'guess'],
                weight: 0.15,
            },
        },
        {
            key: 'project.technicalUncertainty',
            questionNumber: 0,
            label: 'Technical uncertainty',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: [
                    'uncertain',
                    'unknown outcome',
                    'competent professional',
                    'cannot determine',
                    'unpredictable',
                ],
                redFlags: [
                    'routine',
                    'standard practice',
                    'standard engineering',
                    'well-known',
                    'established method',
                ],
                weight: 0.2,
            },
        },
        {
            key: 'project.priorResearch',
            questionNumber: 0,
            label: 'Prior research',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: ['research', 'literature', 'existing', 'prior knowledge', 'insufficient'],
                redFlags: ['no research', "didn't research", 'skipped'],
                weight: 0.15,
            },
        },
        {
            key: 'project.newKnowledge',
            questionNumber: 0,
            label: 'New knowledge',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: ['new knowledge', 'innovation', 'novel', 'advance', 'discover', 'create'],
                redFlags: ['incremental', 'minor improvement'],
                weight: 0.15,
            },
        },
        {
            key: 'project.systematicApproach',
            questionNumber: 0,
            label: 'Systematic approach',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: [
                    'systematic',
                    'methodology',
                    'experiment',
                    'test',
                    'measure',
                    'evaluate',
                    'scientific method',
                ],
                redFlags: ['trial and error', 'trial-and-error', 'ad hoc', 'ad-hoc'],
                weight: 0.1,
            },
        },
        {
            key: 'project.evidence',
            questionNumber: 0,
            label: 'Evidence & documentation',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: [
                    'documentation',
                    'lab notebooks',
                    'test results',
                    'experimental data',
                    'technical records',
                    'evidence',
                ],
                redFlags: ['not documented', 'no records', 'verbal only'],
                weight: 0.08,
            },
        },
    ],
    coreActivity: [
        {
            key: 'core.description',
            questionNumber: 0,
            label: 'Core activity description',
            inputType: 'richText',
            maxChars: 1000,
            required: true,
        },
        {
            key: 'core.hypothesis',
            questionNumber: 0,
            label: 'Hypothesis',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: ['hypothesis', 'we believe', 'expect', 'if', 'then', 'because'],
                redFlags: ['trial and error', 'trial-and-error', 'guess'],
                weight: 0.15,
            },
        },
        {
            key: 'core.technicalUncertainty',
            questionNumber: 0,
            label: 'Technical uncertainty',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: [
                    'uncertain',
                    'unknown outcome',
                    'competent professional',
                    'cannot determine',
                    'unpredictable',
                ],
                redFlags: ['routine', 'standard practice', 'well-known', 'established method'],
                weight: 0.2,
            },
        },
        {
            key: 'core.priorKnowledgeGap',
            questionNumber: 0,
            label: 'Prior knowledge gap',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: [
                    'literature review',
                    'existing methods',
                    'prior research',
                    'knowledge gap',
                    'insufficient solutions',
                    'limitations',
                ],
                redFlags: ['no research', "didn't check", 'not applicable'],
                weight: 0.15,
            },
        },
        {
            key: 'core.scientificPrinciples',
            questionNumber: 0,
            label: 'Scientific principles',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: [
                    'established science',
                    'engineering principles',
                    'theoretical',
                    'scientific basis',
                    'fundamental principles',
                ],
                redFlags: ['common sense', 'intuition', 'guesswork', 'standard practice'],
                weight: 0.12,
            },
        },
        {
            key: 'core.experimentalMethodology',
            questionNumber: 0,
            label: 'Experimental methodology',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: [
                    'experimental design',
                    'controlled testing',
                    'methodology',
                    'systematic',
                    'data collection',
                    'measurement',
                ],
                redFlags: ['informal testing', 'trial and error', 'ad hoc', 'random testing'],
                weight: 0.15,
            },
        },
        {
            key: 'core.expectedOutcomes',
            questionNumber: 0,
            label: 'Expected outcomes',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: [
                    'expected results',
                    'anticipated outcomes',
                    'observable',
                    'measurable',
                    'success criteria',
                ],
                redFlags: ['guaranteed results', 'certain outcome', 'business metrics'],
                weight: 0.1,
            },
        },
        {
            key: 'core.evidence',
            questionNumber: 0,
            label: 'Evidence & documentation',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: ['documentation', 'lab notebooks', 'test results', 'experimental data', 'evidence'],
                redFlags: ['not documented', 'no records', 'verbal only'],
                weight: 0.08,
            },
        },
    ],
    supportingActivity: [
        {
            key: 'support.description',
            questionNumber: 0,
            label: 'Supporting activity description',
            inputType: 'richText',
            maxChars: 1000,
            required: true,
        },
        {
            key: 'support.supportDescription',
            questionNumber: 0,
            label: 'How does this support the core activity?',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: [
                    'enables core R&D',
                    'supports experimentation',
                    'facilitates testing',
                    'necessary for R&D',
                    'directly supports',
                ],
                redFlags: ['general business support', 'administrative', 'routine operations', 'standard IT'],
                weight: 0.15,
            },
        },
        {
            key: 'support.dominantPurpose',
            questionNumber: 0,
            label: 'Dominant purpose',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
            complianceRules: {
                keywords: [
                    'dominant purpose',
                    'prevailing purpose',
                    'primarily for R&D',
                    'main purpose',
                    'ruling purpose',
                ],
                redFlags: ['also used for', 'sometimes supports', 'general purpose', 'dual purpose'],
                weight: 0.15,
            },
        },
        {
            key: 'support.relatedCoreActivityIds',
            questionNumber: 0,
            label: 'Related core activities',
            inputType: 'checkbox',
            options: [], // populated at runtime from sibling core activities
            required: false,
        },
        {
            key: 'support.evidence',
            questionNumber: 0,
            label: 'Evidence & documentation',
            inputType: 'richText',
            maxChars: 1000,
            required: false,
        },
    ],
};
